export const workflowData = {
  career_consult_page: [
    {
      icon_color: "#BCD3FF",
      number: "01",
      title: "Поставим",
      colored_title: "Цели",
      desc: "До оплаты обсудим ваш карьерный запрос, поставим цели на сессию "
    },
    {
      icon_color: "#BCD3FF",
      number: "02",
      title: "Планируем",
      colored_title: "Сессию",
      desc: "Выберем удобное время и забронируем слот для встречи"
    },
    {
      icon_color: "#BCD3FF",
      number: "03",
      title: "Консультация",
      colored_title: "90 минут",
      desc: "Поможем разобраться в текущей ситуации, определить цель и путь ее достижения"
    },
    {
      icon_color: "#BCD3FF",
      number: "04",
      title: "Получаем",
      colored_title: "Результат",
      desc: "После консультации вы получите тезисы консультации и список уникальных полезных материалов"
    },
  ],
  cv_ready_page: [
    {
      icon_color: "#BCD3FF",
      number: "01",
      title: "Поставим",
      colored_title: "Цели",
      desc: "Обсудим запрос до оплаты, поставим цели, выберем время для встреч"
    },
    {
      icon_color: "#BCD3FF",
      number: "02",
      title: "Планируем",
      colored_title: "Работу",
      desc: "Проведем 3 часа в онлайн формате, где создадим ваше новое резюме"
    },
    {
      icon_color: "#BCD3FF",
      number: "03",
      title: "Публикация",
      colored_title: "Резюме",
      desc: "Оформим ваше резюме в шаблон и правильно выложим на нужных сервисах по поиску работы"
    },
    {
      icon_color: "#BCD3FF",
      number: "04",
      title: "Собираем",
      colored_title: "Статистику",
      desc: "В течение месяца будем следить за статистикой вашего резюме"
    },
  ],
  search_support_page: [
    {
      icon_color: "#BCD3FF",
      number: "01",
      title: "Построим",
      colored_title: "Прогноз",
      desc: "Обсудим запрос до оплаты, построим прогноз поиска"
    },
    {
      icon_color: "#BCD3FF",
      number: "02",
      title: "Планируем",
      colored_title: "Подготовку",
      desc: "Создадим Резюме, Linkedin, Сопроводительное письмо и проведем тестовое интервью"
    },
    {
      icon_color: "#BCD3FF",
      number: "03",
      title: "Старт",
      colored_title: "Работы",
      desc: "Приступим к поиску работы: показ вакансий и контактов, работа с откликами"
    },
    {
      icon_color: "#BCD3FF",
      number: "04",
      title: "Будем",
      colored_title: "Рядом 24/7",
      desc: "Консультант будет рядом с вами 24/7 и поможет: пройти интервью, быть в ресурсе и взять оффер"
    },
  ],
  probation_support_page: [
    {
      icon_color: "#C7E8E8",
      number: "01",
      title: "Поставим",
      colored_title: "Цели",
      desc: "Обсудим запрос до оплаты, поставим цели"
    },
    {
      icon_color: "#C7E8E8",
      number: "02",
      title: "Планируем",
      colored_title: "Встречи",
      desc: "Выберем график и время для встреч"
    },
    {
      icon_color: "#C7E8E8",
      number: "03",
      title: "Будем",
      colored_title: "Рядом 24/7",
      desc: "Между встречами эксперт будет отвечать на вопросы и давать рекомендации в чате 24/7"
    },
    {
      icon_color: "#C7E8E8",
      number: "04",
      title: "Получаем",
      colored_title: "Результат",
      desc: "После каждой встречи вы получите тезисы разговора, полезные материалы и домашние задания"
    },
  ],
  vacancies_page: [
    {
      icon_color: "#BCD3FF",
      number: "01",
      title: "Построим",
      colored_title: "Прогноз",
      desc: "Обсудим запрос до оплаты, построим прогноз поиска"
    },
    {
      icon_color: "#BCD3FF",
      number: "02",
      title: "Знакомимся",
      colored_title: "с командой",
      desc: "Знакомим вас с сорсером и обговариваем все критерии поиска"
    },
    {
      icon_color: "#BCD3FF",
      number: "03",
      title: "Старт",
      colored_title: "Работы",
      desc: "Приступим к поиску работы: показ вакансий и контактов, работа с откликами"
    },
    {
      icon_color: "#BCD3FF",
      number: "04",
      title: "Будем",
      colored_title: "Рядом 24/7",
      desc: "Команда будет рядом с вами 24/7 и поможет: быть в ресурсе и взять оффер"
    },
  ],
  talkitout_page: [
    {
      icon_color: "#C7E8E8",
      number: "01",
      title: "Поставим",
      colored_title: "Цели",
      desc: "До оплаты обсудим ваш запрос, поставим цели на сессию"
    },
    {
      icon_color: "#C7E8E8",
      number: "02",
      title: "Планируем",
      colored_title: "Сессию",
      desc: "Выберем удобное время и забронируем слот для встречи"
    },
    {
      icon_color: "#C7E8E8",
      number: "03",
      title: "Встреча",
      colored_title: "60 минут",
      desc: "Вы сможете высказаться, уменьшить тревогу и найти корни текущих проблем"
    },
    {
      icon_color: "#C7E8E8",
      number: "04",
      title: "Получаем",
      colored_title: "Результат",
      desc: "После встречи вы получите тезисы сессии и полезные материалы"
    },
  ],
  it_hiring_page: [
    {
      icon_color: "#96CFFF",
      number: "01",
      title: "Построим",
      colored_title: "Прогнозы",
      desc: "Познакомимся, обсудим запрос, построим прогнозы"
    },
    {
      icon_color: "#96CFFF",
      number: "02",
      title: "Заключаем",
      colored_title: "Договор",
      desc: "Заключим договор и покажем первых кандидатов"
    },
    {
      icon_color: "#96CFFF",
      number: "03",
      title: "Старт",
      colored_title: "Работ",
      desc: "Закроем ваши позиции"
    },
    {
      icon_color: "#96CFFF",
      number: "04",
      title: "Получаем",
      colored_title: "Результат",
      desc: "Поздравим вас и кандидата с успешным прохождением испытательного срока"
    },
  ],
  it_training_page: [
    {
      icon_color: "#C5EAEE",
      number: "01",
      title: "Блок",
      colored_title: "Теории",
      desc: "6 недель теоретического блока: уроки, онлайн разборы, вебинары и дипломная работа"
    },
    {
      icon_color: "#C5EAEE",
      number: "02",
      title: "Практическая",
      colored_title: "Работа",
      desc: "4 недели настоящей работы в роли ИТ рекрутера под присмотром Любови Прохоровой"
    },
    {
      icon_color: "#C5EAEE",
      number: "03",
      title: "Онлайн",
      colored_title: "Выпускной",
      desc: "Проведение онлайн выпускного и карьерная подготовка к поиску работы"
    },
    {
      icon_color: "#C5EAEE",
      number: "04",
      title: "Поиск",
      colored_title: "Работы",
      desc: "4 недели совместного поиска работы: организация интервью с компаниями-партнерами, показ вакансий, помощь с тестовыми заданиями"
    },
  ],
  linkedin_boost_page: [
    {
      icon_color: "#C7E8E8",
      number: "01",
      title: "Анализ и",
      colored_title: "Цели",
      desc: "Разбираем текущий профиль, позиционирование, ЦА и задачи"
    },
    {
      icon_color: "#C7E8E8",
      number: "02",
      title: "Стратегия",
      colored_title: "Профиля",
      desc: "Формируем чёткое позиционирование, выстраиваем стратегию под ваши цели"
    },
    {
      icon_color: "#C7E8E8",
      number: "03",
      title: "Оптимизация",
      colored_title: "Профиля",
      desc: "Оформляем заголовок, общие сведения, опыт и визуал профиля так, чтобы он продавал и приводил нужных людей"
    },
    {
      icon_color: "#C7E8E8",
      number: "04",
      title: "Системная",
      colored_title: "Работа",
      desc: "Выполняем все рутинные действия стратегия, чтобы вы собирали сливки"
    }
  ],
  c_level_page: [
    {
      number: "01",
      title: "Анализ",
      desc: "Конфиденциальная диагностика карьеры"
    },
    {
      number: "02",
      title: "Разработка",
      desc: "Формирование карьерной стратегии"
    },
    {
      number: "03",
      title: "Подготовка",
      desc: "Позиционирование и упаковка профиля"
    },
    {
      number: "04",
      title: "Активация",
      desc: "Работа с рынком и предложениями"
    },
    {
      number: "05",
      title: "Коучинг",
      desc: "Поддержка в переговорах и принятии решений"
    }
  ],
  career_audit_page: [
    {
      icon_color: "#94D4FF",
      number: "01",
      title: "Бриф",
      desc: "Живая встреча с консультантом для разработки плана аудита."
    },
    {
      icon_color: "#94D4FF",
      number: "02",
      title: "HR-интервью",
      desc: "Реальное HR-собеседование: как вы презентуете опыт, как вас считывает рынок. На русском или английском — по вашему выбору."
    },
    {
      icon_color: "#94D4FF",
      number: "03",
      title: "Экспертное интервью",
      desc: "Оценка профессиональных компетенций по вашей специализации практикующим экспертом, подходящим под ваш запрос."
    },
    {
      icon_color: "#94D4FF",
      number: "04",
      title: "Отчёт и финальная встреча",
      desc: "Презентация и письменный отчёт с оценкой уровня и грейда, прогнозом по зарплате, срокам поиска и позициям."
    }
  ],
}
